/**
 * RequireAuth - HOC for protecting routes requiring authentication
 */
import { authLogger } from '@annote/core/utils/debug';
import { ReactNode } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import styled from 'styled-components';
import ComingSoon from 'src/routes/ComingSoon';
import { useProfileContext } from 'src/context/ProfileContext';
import { useDataContext } from 'src/context/DataContext';

const nonRedirectPaths = ['/login', '/login/dev', '/login/auto', '/soon', '/logout'];

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 1.2rem;
  color: #666;
`;

const RequireAuth = ({ children }: { children: ReactNode }): React.ReactElement => {
  const { isInitialized, annoteDB } = useDataContext();
  const location = useLocation();

  // Show loading state while database is being initialized
  if (!isInitialized) {
    return <LoadingContainer>Loading...</LoadingContainer>;
  }

  // Check if user is authenticated (more reliable than just checking profile)
  const isAuthenticated = annoteDB?.profile !== null && annoteDB?.profile !== undefined;

  if (!isAuthenticated) {
    if (location.pathname === '/' && !(location.search.includes('ids=') || location.search.includes('url=')))
      return <ComingSoon />;

    // Save the path they were trying to go to for redirect after login
    if (!nonRedirectPaths.includes(location.pathname)) {
      localStorage.setItem('redirectTo', location.pathname + location.search);
    }
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export const RequireStaff = ({ children }: { children: ReactNode }): React.ReactElement => {
  const { profile } = useProfileContext();
  const { isInitialized } = useDataContext();

  // Show loading state while database is being initialized
  if (!isInitialized) {
    return <LoadingContainer>Loading...</LoadingContainer>;
  }

  if (!profile || !profile.isStaff) {
    authLogger.debug('RequireStaff: profile', profile);
    return <div>You are not staff!</div>;
    // return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

export default RequireAuth;
